export enum EmailVerificationProcess {
  Manual = 'Manual',
  ImportFlow = 'ImportFlow',
}
